import { LogicConstants } from "../Utils/logicConstants";

const isEmpty = (value) => {
  return value === undefined || value === null;
};

const isEmptyArray = (value) => {
  return value === undefined || value === null || value.length === 0;
};

const isEmptyString = (value) => {
  return (
    value === undefined ||
    value === null ||
    value === "" ||
    value.length === 0 ||
    value.trim().length === 0
  );
};

const findParent = (el, id) => {
  if (isEmpty(el)) return null;
  while (true) {
    el = el.parentElement;
    if (isEmpty(el)) return null;
    if (el.id === id) return el;
  }
};
const focusNextElement = () => {
  const focussableElements =
    'input[type=text]:not([disabled]),input[type=password]:not([disabled]),input[type=checkbox]:not([disabled]),input[type=date]:not([disabled]),button.enterFocus,[tabindex]:not([disabled]):not([tabindex="-1"]):not([tabindex="0"])';
  if (document.activeElement) {
    const parent = findParent(document.activeElement, "module");
    if (isEmpty(parent)) {
      return;
    }
    const focussable = Array.prototype.filter.call(
      parent.querySelectorAll(focussableElements),
      function (element) {
        //check for visibility while always include the current activeElement
        return (
          element.offsetWidth > 0 ||
          element.offsetHeight > 0 ||
          element === document.activeElement
        );
      }
    );
    const index = focussable.indexOf(document.activeElement);
    if (index > -1) {
      const nextElement = focussable[index + 1] || focussable[0];
      nextElement.focus();
    }
  }
};

const toCommaSeperatedAmount = (value) => {
  if (!isEmpty(value)) return parseFloat(value).toLocaleString();
  else return parseFloat(0).toFixed(2);
};

function toCommaSeperatedAmount_new(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

const getSuggestions = (list, input) => {
  if (!isEmptyString(input) && !isEmptyArray(list)) {
    const _input = input.trim().toLowerCase();
    return list.filter((suggestion) =>
      suggestion.toLowerCase().includes(_input)
    );
  } else {
    return new Array();
  }
};

const StatusConvertor = (type, value) => {
  let status = "";
  if (type == 1) {
    if (LogicConstants.INVOICE_APPROVE_STATUS === value) {
      status = "APPROVED";
    }
    if (LogicConstants.INVOICE_UNAPPROVE_STATUS === value) {
      status = "UNAPPROVED";
    }
    if (LogicConstants.INVOICE_OPEN_STATUS === value) {
      status = "OPEN";
    }
    if (LogicConstants.INVOICE_PAID_STATUS === value) {
      status = "PAID";
    }
    if (LogicConstants.INVOICE_PARTIALLY_PAID_STATUS === value) {
      status = "PARTIALLY PAID";
    }
    if (LogicConstants.INVOICE_CANCEL_STATUS === value) {
      status = "CANCELLED";
    }
    return status;
  } else if (type == 2) {
    if (LogicConstants.LOGISTIC_ORDER_APPROVE_STATUS === value) {
      status = "APPROVED";
    }
    if (LogicConstants.LOGISTIC_ORDER_UNAPPROVE_STATUS === value) {
      status = "UNAPPROVED";
    }
    if (LogicConstants.LOGISTIC_ORDER_CANCEL_STATUS === value) {
      status = "CANCEL";
    }
    if (LogicConstants.LOGISTIC_ORDER_CLOSE_STATUS === value) {
      status = "CLOSED";
    }
    if (LogicConstants.LOGISTIC_ORDER_RECEIVED_STATUS === value) {
      status = "RECEIVED";
    }
    
     if (LogicConstants.INVOICE_OPEN_STATUS === value) {
      status = "OPEN";
    }
    return status;
  }
   else if (type == 3) {
    if (LogicConstants.SALES_ORDER_APPROVE_STATUS === value) {
      status = "APPROVED";
    }
    if (LogicConstants.SALES_ORDER_UNAPPROVE_STATUS === value) {
      status = "UNAPPROVED";
    }
    if (LogicConstants.SALES_ORDER_CANCEL_STATUS === value) {
      status = "CANCEL";
    }
    if (LogicConstants.SALES_ORDER_CLOSE_STATUS === value) {
      status = "CLOSED";
    }
    if (LogicConstants.SALES_ORDER_PARTIALLY_PICKED_STATUS === value) {
      status = "PARTIALLY PICKED";
    }
     if (LogicConstants.SALES_ORDER_PARTIALLY_INVOICED_STATUS === value) {
      status = "PARTIALLY INVOICED";
    }
    if (LogicConstants.SALES_ORDER_INVOICED_STATUS === value) {
      status = "INVOICED";
    }
    if (LogicConstants.SALES_ORDER_PICKED_STATUS === value) {
      status = "PICKED";
    }
    return status;
  }
  else if (type == 4) {
      if (LogicConstants.SALES_ORDER_LINE_OPEN_STATUS === value) {
      status = "OPEN";
    }
     if (LogicConstants.SALES_ORDER_LINE_SHIPPED_STATUS === value) {
      status = "SHIPPED";
    }
     if (LogicConstants.SALES_ORDER_LINE_CANCEL_STATUS === value) {
      status = "CANCEL";
    }
     if (LogicConstants.SALES_ORDER_LINE_CLOSE_STATUS === value) {
      status = "CLOSE";
    }
     if (LogicConstants.SALES_ORDER_LINE_SHIPED_CANCEL_STATUS === value) {
      status = "SHIPED CANCEL";
    }
     if (LogicConstants.SALES_ORDER_LINE_SHIPED_CLOSE_STATUS === value) {
      status = "SHIPED CLOSE";
    }
     if (LogicConstants.SALES_ORDER_LINE_PARTIALLY_SHIPPED_STATUS === value) {
      status = "PARTIALLY SHIPPED";
    }
     if (LogicConstants.SALES_ORDER_LINE_PACKED_STATUS === value) {
      status = "LINE PACKED";
    }
     if (LogicConstants.SALES_ORDER_LINE_PARTIALLY_PACKED_STATUS === value) {
      status = "LINE PARTIALLY PACKED";
    }
     if (LogicConstants.SALES_ORDER_LINE_PACKED_CANCEL_STATUS === value) {
      status = "LINE PACKED CANCEL";
    }
     if (LogicConstants.SALES_ORDER_LINE_PACKED_CLOSE_STATUS === value) {
      status = "LINE PACKED CLOSE";
    }
      return status;
    }
};


const dateFormate = (value) => {
  if (value != null && value != undefined && value != "Invalid Date") {
    const today = new Date(value);
    const mm = today.getMonth() + 1; // getMonth() returns month index (0-11)
    const dd = today.getDate();
    const yyyy = today.getFullYear();
    const formattedDate = `${mm < 10 ? '0' + mm : mm}/${dd < 10 ? '0' + dd : dd}/${yyyy}`;
    return formattedDate;
  } else {
    return value;
  }
};


class ColumnDefinition {
  constructor() {
    this.header = "";
    this.isHeaderButton = false;
    this.headerRender = null;
    this.headerClickHandler = null;
    this.headerDisable = null;
    this.accessor = "";
    this.sortable = false;
    this.isNumeric = false;
    this.alignment = "";
    this.isHyperLink = false;
    this.isButton = false;
    this.clickHandler = null;
    this.buttonRender = null;
    this.isInputTexBox = false;
    this.isCheckBox = false;
    this.isNumberFormat = false;
    this.inputOnChange = null;
    this.checkBoxOnChange = null;
    this.inputOnBlur = null;
    this.isImage = false;
    this.getImageUrl = null;
    this.imageLinkCallBack = null;
    this.mininWidth = "";
    this.maxWidth = "";
    this.isStatus = false;
    this.getStatusCaption = null;
    this.isGraph = false;
    this.getGraph = null;
    this.customStyle = "";
    this.headerStyle = "";
    this.isSubHeader = "";
    this.subHeaderAccessor = "";
    this.isColSpan = false;
    this.isTopHeader = false;
    this.colSpan = 0;
    this.isSpecial = false;
    this.specialAccessor = "";
    this.disable = false;
	this.isValueConverter = null;
   this.isDateFormate = false;
  }

  setDetails = (header, accessor, sortable, isNumeric,isDateFormate) => {
    this.header = header;
    this.accessor = accessor;
    this.sortable = sortable;
    this.isNumeric = isNumeric;
     this.isDateFormate = isDateFormate;
    return this;
  };

  setHeaderDetails = (
    isHeaderButton,
    headerRender,
    headerClickHandler,
    headerDisable
  ) => {
    this.isHeaderButton = isHeaderButton;
    this.headerRender = headerRender;
    this.headerClickHandler = headerClickHandler;
    this.headerDisable = headerDisable;
    return this;
  };

  setSubHeaderDetails = (isSubHeader, subHeaderAccessor) => {
    this.isSubHeader = isSubHeader;
    this.subHeaderAccessor = subHeaderAccessor;
    return this;
  };

  setStyleDetails = (
    alignment,
    mininWidth,
    maxWidth,
    customStyle,
    headerStyle
  ) => {
    this.alignment = alignment;
    this.mininWidth = mininWidth;
    this.maxWidth = maxWidth;
    this.customStyle = customStyle;
    this.headerStyle = headerStyle;
    return this;
  };

  setSpanDetails = (isColSpan, isTopHeader, colSpan) => {
    this.isColSpan = isColSpan;
    this.isTopHeader = isTopHeader;
    this.colSpan = colSpan;
    return this;
  };

  setInputDetails = (
    isInputTexBox,
    isNumberFormat,
    isCheckBox,
    inputOnChange,
    checkBoxOnChange,
    inputOnBlur
  ) => {
    this.isInputTexBox = isInputTexBox;
    this.isNumberFormat = isNumberFormat;
    this.isCheckBox = isCheckBox;
    this.inputOnChange = inputOnChange;
    this.checkBoxOnChange = checkBoxOnChange;
    this.inputOnBlur = inputOnBlur;
    return this;
  };

  setClickDetails = (isHyperLink, isButton, clickHandler, buttonRender) => {
    this.isHyperLink = isHyperLink;
    this.isButton = isButton;
    this.clickHandler = clickHandler;
    this.buttonRender = buttonRender;
    return this;
  };

  setImageDetails = (isImage, getImageUrl, imageLinkCallBack) => {
    this.isImage = isImage;
    this.getImageUrl = getImageUrl;
    this.imageLinkCallBack = imageLinkCallBack;
    return this;
  };

  setStatusDetails = (isStatus, getStatusCaption) => {
    this.isStatus = isStatus;
    this.getStatusCaption = getStatusCaption;
    return this;
  };

  setGraphDetails = (isGraph, getGraph) => {
    this.isGraph = isGraph;
    this.getGraph = getGraph;
    return this;
  };

  setSpecialDetails = (isSpecial, specialAccessor) => {
    this.isSpecial = isSpecial;
    this.specialAccessor = specialAccessor;
    return this;
  };
  setDisabled = (disable) => {
    this.disable = disable;
    return this;
  };
  
  setValueConveter = (isValueConverter, getValueConverter) => {
    this.isValueConverter = isValueConverter;
    this.getValueConverter = getValueConverter;
    return this;
  };
  
}

export {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  focusNextElement,
  toCommaSeperatedAmount,
  getSuggestions,
  StatusConvertor,
    dateFormate,
  ColumnDefinition,

};
